import React, { useContext } from "react";
import { useHistory } from "react-router-dom";
import { GlobalContext } from "../../../Contexts/GlobalContextProvider";
import "./CardWrap.css";

export default function CardWrap(props) {
  const { step } = props;
  const history = useHistory();
  const { isMobile } = useContext(GlobalContext);

  return (
    <div className="p-2">
      <div className="row pl-2 pt-2">
        {step ? (
          <div className="container">
            <ol className="progress-meter">
              <li className={`progress-point ${step >= 1 ? "done" : "todo"}`}>
                {!isMobile ? "Podaci o poslovnom subjektu" : ""}
              </li>
              <li className={`progress-point ${step >= 2 ? "done" : "todo"}`}>
                {!isMobile ? "Podaci o vlasniku" : ""}
              </li>
              <li className={`progress-point ${step >= 3 ? "done" : "todo"}`}>
                {!isMobile ? "Prodajna mjesta" : ""}
              </li>
              <li className={`progress-point ${step >= 4 ? "done" : "todo"}`}>
                {!isMobile ? "Podaci o cjenicima" : ""}
              </li>
              <li className={`progress-point ${step >= 5 ? "done" : "todo"}`}>
                {!isMobile ? "Podaci o certifikatu" : ""}
              </li>
              <li className={`progress-point ${step >= 6 ? "done" : "todo"}`}>
                {!isMobile ? "Provjera podataka" : ""}
              </li>
            </ol>
          </div>
        ) : (
          ""
        )}
      </div>
      <div className="card container-fluid p-0">
        {props.subtitle && (
          <div className="card-header card-wrap">
            <span>
              {props.subtitle}{" "}
              {props.entity != undefined ? `- ${props.entity}` : ""}
            </span>
            {props.backUrl ? (
              <button
                className="btn btn-sm btn-outline-secondary web-hidden"
                onClick={() => history.push(props.backUrl)}
                style={{ float: "right" }}
              >
                <span className="icon icon-cancel"></span>
              </button>
            ) : null}
          </div>
        )}

        <div className="card-body">{props.children}</div>
      </div>
    </div>
  );
}
